// 复制到粘贴板
import dayjs from "dayjs";

export const copyToClipboard = (text) => {
  const input = document.createElement('input');
  document.body.appendChild(input);
  input.setAttribute('value', text);
  input.select();
  if (document.execCommand('copy')) {
      document.execCommand('copy');
      console.success('复制成功');
  } else {
    console.error('复制失败');
  }
  document.body.removeChild(input);
}
export function isSameDay(date1, date2) {
  // 将日期转换为Date对象（如果传入的不是Date对象）
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  // 获取年、月、日，注意月份是从0开始的，所以要加1
  const year1 = d1.getFullYear();
  const month1 = d1.getMonth() + 1;
  const day1 = d1.getDate();

  const year2 = d2.getFullYear();
  const month2 = d2.getMonth() + 1;
  const day2 = d2.getDate();

  // 比较年月日是否相等
  return year1 === year2 && month1 === month2 && day1 === day2;
}
const format = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';
export const dayjsFormat = (value) => {
  return dayjs(value).format(format);
};